import { render, staticRenderFns } from "./OrdersFBAHead.vue?vue&type=template&id=0e560a50&scoped=true"
import script from "./OrdersFBAHead.vue?vue&type=script&lang=js"
export * from "./OrdersFBAHead.vue?vue&type=script&lang=js"
import style0 from "./OrdersFBAHead.vue?vue&type=style&index=0&id=0e560a50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e560a50",
  null
  
)

export default component.exports